import axios from 'axios';
import { ROUTE_LOGIN } from 'RouteList';

const BASE_URL = process.env.REACT_APP_BASE_PATH;

axios.defaults.baseURL = BASE_URL;

/**
 * load all analisis for the logged in user
 * we need to pass the uid of the user
 * retrieves analisis
 */
export async function uploadVideo({ filename, file, onUploadProgress }) {
  console.log('-> Uploading video...');
  try {
    const options = {
      headers: {
        key: filename,
        'content-type': file.type
      }
    };
    const s3HeaderResult = await axios.get(
      'https://us-central1-v-observer.cloudfunctions.net/S3header',
      options
    );
    const uploadConfig = {
      onUploadProgress
    };
    await axios.put(s3HeaderResult.data.url, file, uploadConfig);
    console.log('-> Video uploaded');
    console.log('-> Transcoding video...');
  } catch (error) {
    console.log('error');
    throw error;
  }
}

export function errorHandler(error, router) {
  console.log(error);
  if (error.response.status === 401) {
    router.push(ROUTE_LOGIN);
  }
}
